var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333252,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E7EDFC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7847_26580",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 25,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.3333,
    y: 12,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7847_26580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 33C16.7833 33 16.3124 32.8042 15.9208 32.4125C15.5291 32.0208 15.3333 31.55 15.3333 31V17C15.3333 16.45 15.5291 15.9792 15.9208 15.5875C16.3124 15.1958 16.7833 15 17.3333 15H31.3333C31.8833 15 32.3541 15.1958 32.7458 15.5875C33.1374 15.9792 33.3333 16.45 33.3333 17H25.3333C24.1499 17 23.1874 17.3708 22.4458 18.1125C21.7041 18.8542 21.3333 19.8167 21.3333 21V27C21.3333 28.1833 21.7041 29.1458 22.4458 29.8875C23.1874 30.6292 24.1499 31 25.3333 31H33.3333C33.3333 31.55 33.1374 32.0208 32.7458 32.4125C32.3541 32.8042 31.8833 33 31.3333 33H17.3333ZM25.3333 29C24.7833 29 24.3124 28.8042 23.9208 28.4125C23.5291 28.0208 23.3333 27.55 23.3333 27V21C23.3333 20.45 23.5291 19.9792 23.9208 19.5875C24.3124 19.1958 24.7833 19 25.3333 19H32.3333C32.8833 19 33.3541 19.1958 33.7458 19.5875C34.1374 19.9792 34.3333 20.45 34.3333 21V27C34.3333 27.55 34.1374 28.0208 33.7458 28.4125C33.3541 28.8042 32.8833 29 32.3333 29H25.3333ZM28.3333 25.5C28.7666 25.5 29.1249 25.3583 29.4083 25.075C29.6916 24.7917 29.8333 24.4333 29.8333 24C29.8333 23.5667 29.6916 23.2083 29.4083 22.925C29.1249 22.6417 28.7666 22.5 28.3333 22.5C27.8999 22.5 27.5416 22.6417 27.2583 22.925C26.9749 23.2083 26.8333 23.5667 26.8333 24C26.8333 24.4333 26.9749 24.7917 27.2583 25.075C27.5416 25.3583 27.8999 25.5 28.3333 25.5Z",
    fill: "#41558D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/Wallet.37c509c0500f0edca06dbd52357a241e.svg";
export { ForwardRef as ReactComponent };